import { memo } from 'react'
import MultipleInputSkeleton from 'components/SkeletonView/MultipleInputSkeleton'
import useStore from 'stores/utils/hooks/useStore'
import { Debtor } from 'containers/PersonalForm/PersonalForm.interface'

const ActiveLoansSkeleton = ({ debtor = Debtor.PRIMARY }) => {
  const debtors = useStore((store) => store.traversal.data.debtors)

  const loanCount = debtors[debtor].numberOfActiveLoans

  if (loanCount === 0) {
    return <MultipleInputSkeleton count={1} />
  }

  return <MultipleInputSkeleton count={loanCount * 6} />
}

const MemoizedActiveLoansSkeleton = memo(ActiveLoansSkeleton)

// eslint-disable-next-line react/display-name
const ActiveLoansSkeletonFunc = (debtor: Debtor) => () => (
  <MemoizedActiveLoansSkeleton debtor={debtor} />
)

export default ActiveLoansSkeletonFunc
